import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-169">
      <div className="max-w-4xl mx-auto text-center" data-id="element-170">
        {/* Logo */}
        <div className="text-[#00B4D8] text-3xl font-black tracking-widest mb-8" data-id="element-171">
          🎾 PROFEPACK™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-172">
          El próximo lunes podés volver a improvisar la clase.
        </h2>
        <p className="text-[#00B4D8] text-2xl sm:text-3xl font-black mb-10" data-id="element-173">
          O podés entrar a la cancha con todo resuelto desde hoy.
        </p>

        {/* Cost Table */}
        <div className="bg-[#001a2d] border border-[#00B4D8]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-174">
          <div className="p-4 bg-[#000d1a] border-b border-[#00B4D8]/30 text-center font-bold text-white" data-id="element-175">
            ¿Cuánto cuesta NO tenerlo?
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 bg-[#000d1a] border-b border-[#00B4D8]/30" data-id="element-176">
            <div className="p-4 font-bold text-gray-400 text-center" data-id="element-177">
              SIN MEGAPACK
            </div>
            <div className="p-4 font-bold text-[#00B4D8] text-center sm:border-l border-[#00B4D8]/30" data-id="element-178">
              CON MEGAPACK
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-179">
            <div className="p-4 text-gray-400 text-sm" data-id="element-180">
              100+ horas/año planificando desde cero
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-181">
              10 min/semana. El resto es enseñar.
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-182">
            <div className="p-4 text-gray-400 text-sm" data-id="element-183">
              Drills improvisados → mismo error por meses
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-184">
              60 drills listos → se resuelve en la clase
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-185">
            <div className="p-4 text-gray-400 text-sm" data-id="element-186">
              60% de abandono antes del año
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-187">
              Sistema de fidelización → retención +75%
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-188">
            <div className="p-4 text-gray-400 text-sm" data-id="element-189">
              Sin progresión clara por nivel
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-190">
              6 tomos con categorías argentinas → suben y recomiendan
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-191">
            <div className="p-4 text-gray-400 text-sm" data-id="element-192">
              Lluvia = cancelación = sin cobro
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-193">
              Kit Anti-Lluvia: 12 clases Plan B listas
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-194">
            <div className="p-4 text-gray-400 text-sm" data-id="element-195">
              Niveles mezclados = caos
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-196">
              6 rotaciones listas → todos mejoran juntos
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-197">
            <div className="p-4 text-gray-400 text-sm" data-id="element-198">
              Cobro irregular e incómodo
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-199">
              Abono blindado → cobro el día 1-5
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-200">
            <div className="p-4 text-gray-400 text-sm" data-id="element-201">
              Sin identidad profesional
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-202">
              Sistema de negocio que justifica cobrar más
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-203">
            <div className="p-4 text-gray-400 text-sm" data-id="element-204">
              Contrato verbal que termina en conflicto
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-205">
              Reglamento + Contrato Ético listos para usar
            </div>
          </div>
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-206">
          <p className="text-white font-bold mb-4" data-id="element-207">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-208" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-209">
          Después sube{' '}
          <span className="text-[#FF0000] font-bold" data-id="element-210">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-211">
          <div className="bg-[#0a0a0a] border border-[#00B4D8]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-212">
            <div className="text-2xl mb-2" data-id="element-213">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-214">MEGAPACK PADEL LISTO</h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-215">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-216">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-217">
                Antes: $34.990 ARS
              </p>
              <p className="text-[#00B4D8] text-2xl font-black mb-4" data-id="element-218">
                Hoy: $19.990 ARS
              </p>
              <a href="#pricing" className="btn-green-pulse block bg-[#00B4D8] text-black font-black py-4 rounded-lg hover:bg-[#38BDF8] transition-colors text-sm" data-id="element-219">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-[#000d1a] border-2 border-[#00B4D8] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(0,180,216,0.2)] flex flex-col" data-id="element-220">
            <div className="text-2xl mb-2" data-id="element-221">🏆</div>
            <h3 className="text-[#00B4D8] font-black mb-1" data-id="element-222">
              MEGAPACK + PÁDEL PRO BUSINESS ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-1" data-id="element-223">La más elegida</p>
            <p className="text-gray-400 text-xs mb-4" data-id="element-224">
              6 Tomos + 6 Bonos + Pádel Pro Business™
              <br data-id="element-225" />
              (cobro, clínicas, captación y negocio)
            </p>
            <div className="mt-auto" data-id="element-226">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-227">
                Antes: $43.990 ARS
              </p>
              <p className="text-[#00B4D8] text-3xl font-black mb-4" data-id="element-228">
                Hoy: $27.990 ARS
              </p>
              <a href="#pricing" className="btn-green-pulse block bg-[#00B4D8] text-black font-black py-4 rounded-lg hover:bg-[#38BDF8] transition-colors text-sm" data-id="element-229">
                → QUIERO EL MEGAPACK + PÁDEL PRO BUSINESS
              </a>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-230">
          <span data-id="element-231">🔒 Pago 100% seguro</span>
          <span data-id="element-232">⚡ Acceso en 5 minutos</span>
          <span data-id="element-233">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-234">
            💳 Mercado Pago | Tarjeta de crédito | Transferencia bancaria
          </span>
        </div>
      </div>
    </section>;
}